var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.016 12.65-1.358-1.323a.88.88 0 0 0-.644-.255.92.92 0 0 0-.667.278.88.88 0 0 0-.258.65q0 .395.258.65l2.014 1.995a.9.9 0 0 0 .655.279q.375 0 .656-.279l3.981-3.944a.85.85 0 0 0 .27-.65.97.97 0 0 0-.27-.65.96.96 0 0 0-.667-.29.88.88 0 0 0-.668.267zm-2.623 8.4-1.358-2.275-2.576-.557a.88.88 0 0 1-.562-.36.86.86 0 0 1-.164-.637l.258-2.622-1.757-1.996A.86.86 0 0 1 2 12q0-.348.234-.603L3.991 9.4 3.733 6.78a.86.86 0 0 1 .164-.638.88.88 0 0 1 .562-.36l2.576-.556L8.393 2.95a.92.92 0 0 1 .516-.406.92.92 0 0 1 .655.035L12 3.6l2.436-1.02a.92.92 0 0 1 .655-.035.92.92 0 0 1 .516.406l1.358 2.274 2.576.557a.88.88 0 0 1 .562.36q.21.29.164.637l-.258 2.622 1.757 1.996Q22 11.652 22 12a.86.86 0 0 1-.234.603L20.009 14.6l.258 2.622a.86.86 0 0 1-.164.638.88.88 0 0 1-.562.36l-2.576.556-1.358 2.274a.92.92 0 0 1-.516.406.92.92 0 0 1-.655-.035L12 20.4l-2.436 1.02a.92.92 0 0 1-.655.035.92.92 0 0 1-.516-.406"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedFill);
export default __webpack_public_path__ + "static/media/verified_fill.c0a28905e2468b4cf6b80184954e2f6c.svg";
export { ForwardRef as ReactComponent };